export const ListContent = [
  'Struggling with finding the right words \nto tell your brand\'s story;',
  'Feeling chaotic, overwhelmed, \nand confused when it comes to your website copy;',
  'Wishing your website would just write itself;',
  'Dreaming about increasing your brand recognition and sales;',
  'Tired of seeing your ROI in negative;',
  'Interested in ways to outsource and increase your productivity;',
];